/*
 *   File : list.js
 *   Author : https://evoqins.com
 *   Description : List added questionnaire.
 *   Integrations : 'react-toastify'
 *   Version : 1.0.0
*/

// custom packages
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'bootstrap';

// custom components
import { PrimaryButton, SecondaryButton, TextButton } from '../../Components/Buttons';
import { CustomDataTable } from '../../Components/DataTable';
import { ConfirmModal, ViewQuestionModal } from '../../Components/Modal';
import { APIService } from '../../Service';
import EmptyScreen from '../../Components/Others/empty-screen';


const QuestionList = () => {

    const navigate = useNavigate();
    const isRendered = useRef(true);

    const [currentPage, setCurrentPage] = useState(1);

    const [viewQuestion, setViewQuestion] = useState(false);
    const [confirm, setConfirm] = useState(false);
    const [status, setStatus] = useState(false);
    const [onPaginationChange, setOnPaginationChange] = useState(false);
    const [loader, setLoader] = useState(true);
    const [questionList, setQuestionList] = useState({});
    const [deleteQuestion, setDeleteQuestion] = useState();
    const [view, setView] = useState(null);

    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth'
        });
        if (isRendered.current === true) {
            _handleRiskAssessment();

        }
        isRendered.current = false;
    }, []);

    useEffect(() => {
        if (viewQuestion === true) {
            const open_modal = new Modal(document.getElementById("view-question-modal"));
            open_modal.show();
        }
    }, [viewQuestion]);

    useEffect(() => {
        if (confirm === true) {
            const confirm_modal = new Modal(document.getElementById('confirm-modal'));
            confirm_modal.show();
        }
    }, [confirm]);

    // handle table page change 
    const _handleTablePageChange = (page_num) => {
        setCurrentPage(page_num);
        _handleRiskAssessment(page_num);
    };

    // handle navigate edit log
    const _handleViewEditLog = () => {
        navigate("edit-log");
    };

    // handle edit question
    const _handleEditQuestion = (data) => {
        navigate("manage-questionnaire", {
            state: data
        }
        );
    };

    // handle navigate set risk profile
    const _handleManageRisk = () => {
        navigate("manage-risk");
    };

    // handle navigate manage questionnaire
    const _handleManageQuestionnaire = () => {
        navigate("manage-questionnaire");
    };

    // handle view question 
    const _handleViewQuestion = (row) => {
        setViewQuestion(true);
        // _handleRiskAssessment();
        setView(row);
    };

    // handle delete question
    const _handleDelete = (question_id) => {
        setConfirm(true);
        setDeleteQuestion(question_id)
    };

    // questions data table column 
    const TABLE_COLUMN = [
        {
            name: 'Question',
            cell: (row) =>
                <p className='text-truncate truncate-third-line mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px'>
                    {row.question}
                </p>,
            width: "350px"
        },
        {
            name: 'Weightage',
            cell: (row) =>
                <p className='text-truncate truncate-third-line mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px'>
                    {row.weight_text}
                </p>,
            width: "160px"
        },
        {
            name: 'Question type',
            selector: row => row.question_type_text,
            width: "160px"
        },
        {
            name: '',
            cell: (row) =>
                <TextButton name="View"
                    className='e-hover'
                    onClick={() => _handleViewQuestion(row)} />,
            width: "100px"
        },
        {
            name: '',
            cell: (row) =>
                <TextButton name="Edit"
                    className='e-hover'
                    onClick={() => _handleEditQuestion(row)} />,
            width: "100px"
        },
        {
            name: '',
            cell: (row) =>
                <TextButton name="Delete"
                    className='e-hover'
                    onClick={() => _handleDelete(row.question_id)} />,
            width: "120px"
        }
    ];

    // API - Delete question
    const _deleteQuestion = (question_id) => {
        let is_post = true;
        let url = 'manage-risk/delete';
        let request = {
            "question_id": question_id
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setStatus(true);
            }
            else {
                toast.dismiss();
                toast.error(response.message, { type: "error" });
            }
        })
    }


    // API - Risk assessment
    const _handleRiskAssessment = (page_num = currentPage) => {
        let is_post = true;
        let url = 'manage-risk/list';
        let request = {
            "page_num": page_num,
            "page_size": 10
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setQuestionList(response.data);
            } else {
                setQuestionList({ data: [] })
            }
            setLoader(false);
        })
    };



    return (
        <Fragment>
            <section className='e-section-height pb-5' >
                <div className='e-bg-lavender padding-52px-lr pt-2 padding-112px-bottom'>
                    <h3 className='mb-0 e-text-chinese-black e-primary-font e-font-24 e-font-weight-600 line-height-24px'>
                        Manage Risk Assessment
                    </h3>
                </div>

                {/* Questions list */}
                <div className='padding-52px-lr margin--80px-top'>
                    <div className='e-bg-white border-radius-16 padding-32px-tb '>
                        <div className='padding-32px-lr d-flex justify-content-between align-items-center'>
                            <h4 className='mb-0 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                                Questions list
                            </h4>

                            {/* Buttons */}
                            <div className='d-flex align-items-center gap-4'>
                                <TextButton name="View Edit Log"
                                    className="padding-12px-tb padding-10px-lr e-hover"
                                    onClick={_handleViewEditLog} />

                                <SecondaryButton name="Set Risk Profile Score"
                                    paddingBlock="padding-12px-tb px-3"
                                    className="e-text-chinese-black"
                                    onClick={_handleManageRisk} />

                                <PrimaryButton name="Create Question"
                                    paddingBlock="padding-12px-tb padding-22px-lr"
                                    onClick={_handleManageQuestionnaire} />
                            </div>
                        </div>

                        {/* Question list table */}
                        {loader ?
                            <div className='d-flex align-items-center justify-content-center min-vh-100'>
                                <img src={require("../../Assets/Image/loader.gif")}
                                    draggable={false}
                                    width={80}
                                    height={80}
                                    alt='loader'
                                    className='text-center' />
                            </div>
                            :
                            questionList.data.length > 0 ?
                                <div className='e-data-table-wrapper-default-updated pt-4 padding-32px-bottom'>
                                    <CustomDataTable columns={TABLE_COLUMN}
                                        data={questionList.data}
                                        pagination={questionList.total_count > 10 ? true : false}
                                        paginationPerPage={10}
                                        lastPage={questionList.total_page}
                                        paginationDefaultPage={questionList.current_page}
                                        paginationTotalRows={questionList.total_count}
                                        onChangePage={_handleTablePageChange} />
                                </div>
                                :
                                <EmptyScreen
                                    image={require('../../Assets/Image/NotFound/no-data.png')}
                                    title='No results found'
                                    description={`We couldn' t find anything that matches your search. Try checking your spelling, using different keywords, or exploring popular funds.`}
                                />
                        }

                    </div>
                </div>
            </section>

            {/* view added question modal */}
            {viewQuestion === true &&
                <ViewQuestionModal data={view}
                    handleClose={() => {
                        setTimeout(() => {
                            setViewQuestion(false);
                        }, 200);
                    }} />
            }

            {/* confirm delete modal */}
            {confirm === true &&
                <ConfirmModal title={status ? "Confirm successfully" : "Confirm Delete Question"}
                    description={status ? "The question deleted successfully." : "Are you sure you want to delete this question? This action is permanent and cannot be undone."}
                    buttonText={"Delete"}
                    // data={deleteQuestion}
                    status={status}
                    handleClose={() => {
                        setTimeout(() => {
                            setConfirm(false);
                            setStatus(false);
                        }, 200);
                    }}
                    handleConfirm={() =>
                        _deleteQuestion(deleteQuestion)
                    }
                    handleSuccess={() => {
                        navigate('/risk-assessment');
                        setTimeout(() => {
                            _handleRiskAssessment();
                            setConfirm(false);
                            setLoader(true);
                            setStatus(false);
                        }, 200);
                    }} />
            }
        </Fragment>
    )
}

export default QuestionList;
